module.exports = __webpack_public_path__ + "static/img/home_pic2.da41e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home2/home_pic2.png
// module id = Cta4
// module chunks = 1